import React from "react";
import MotfDefinitionForm from "./MotfDefinitionForm";

export default function OrganizationMotfCreate({ id }: { id: string }) {
    return <MotfDefinitionForm orgId={id} />;
}
